import baseColors from '@shop/styleguide/dist/js/colors/zooplus-colors';

const colors = {
  primary: {
    subtle: baseColors.primarySubtle,
    light: baseColors.primaryLight,
    base: baseColors.primary,
    dark: baseColors.primaryDark,
    gradient: baseColors.primaryGradient
  },
  secondary: {
    subtle: baseColors.secondarySubtle,
    light: baseColors.secondaryLight,
    base: baseColors.secondary,
    dark: baseColors.secondaryDark,
    gradient: baseColors.secondaryGradient
  },
  tertiary: {
    subtle: baseColors.tertiarySubtle, // TODO: We should think about this, because zooplus does not have a 3rd color
    light: baseColors.greyChateau,
    base: baseColors.grey,
    dark: '#434343', // TODO: Check this, should we add to style guide?
    gradient: baseColors.tertiaryGradient
  },
  greyscale: {
    white: baseColors.white,
    subtle: baseColors.antiFlashWhite,
    light: baseColors.whisper,
    base: baseColors.greyChateau,
    dark: baseColors.grey,
    darker: baseColors.charcoal,
    black: baseColors.matterhorn
  },
  accents: {
    info: baseColors.info,
    success: baseColors.success,
    error: baseColors.error,
    warning: baseColors.warning,
    highlight: baseColors.highlight,
    disable: baseColors.disabled
  },
  others: {
    middleBar: baseColors.white,
    crown: baseColors.crown,
    subscription: baseColors.subscription,
    fastshipping: baseColors.fastShipping,
    shadow: baseColors.shadow
  }
};

const typography = {
  fontSize: {
    fs1: '10px',
    fs2: '12px',
    fs3: '14px',
    fs4: '16px',
    fs5: '18px',
    fs6: '20px',
    fs7: '22px',
    fs8: '24px',
    fs9: '28px',
    fs10: '32px',
    base: '14px'
  },
  lineHeight: {
    lh1: '14px',
    lh2: '16px',
    lh3: '18px',
    lh4: '20px',
    lh5: '22px',
    lh6: '24px',
    lh7: '26px',
    lh8: '29px',
    lh9: '36px',
    lh10: '38px',
    base: '1.45'
  },
  iconSize: {
    is1: '16px',
    is2: '18px',
    is3: '20px',
    is4: '24px',
    is5: '28px',
    is6: '32px',
    is7: '36px',
    is8: '40px',
    is9: '43px',
    is10: '50px',
    is11: '57px',
    is12: '64px',
    is13: '72px',
    base: '24px'
  },
  fontFamilies: {
    ff1: 'Arial,sans-serif'
  }
};

export default {
  colors,
  typography
}
